import React, { useState, useContext, useEffect } from "react";
import Head from "../Head/Head";
import Squares from "../Squares/Squares";
import Text from "../Text/Text";
import Elements from "../Elements/Elements";
import "./StepFour.scss";

import { SquareContext } from "../../SquareContext";

import polishred from "../../assets/polishred.svg";

function Stepfour(props) {
  const {
    unitImg,
    cartItems,
    listPortion,
    initialColor,
    activeColor,
    portion,
    stepDesc,
    cart,
    isAdded,
    unity2,
    unity3,
  } = useContext(SquareContext);

  const [btnColor4, setBtnColor4] = useState(initialColor);

  const handleNext = () => {
    if (btnColor4 === activeColor) {
      props.next();
    }
  };

  useEffect(() => {
    if (portion.find((obj) => obj.id !== null)) {
      setBtnColor4(activeColor);
    } else {
      setBtnColor4(initialColor);
    }
  }, [portion, activeColor, initialColor]);

  useEffect(() => {
    if (cart.length === 0) {
      props.jump(1);
    }
  }, [cart]);

  useEffect(() => {
    if (unity2 === 0 && cart[1] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (unity3 === 0 && cart[2] !== undefined) {
      props.jump(3);
    }
  }, [cart, unity2]);

  useEffect(() => {
    if (cart[1] === undefined) {
    }
  }, []);

  // useEffect(() => {
  //   if (isAdded){
  //     props.jump(3)
  //   }else {

  //   }
  // },[isAdded])
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="stepFour">
     

        {stepDesc[3] && (
        <div>
     
          <div className="head">
            <p className="head-red">STEP 4</p>
            <p className="head-line">I</p>
            <p  dangerouslySetInnerHTML={{ __html: stepDesc[3].title }}></p>
          </div>
        </div>
      )}

        <div className="stone">
          <Squares
            first={() => {
              if (props.order === 4) {
                props.jump(1);
              } else {
                props.jump(4);
              }
            }}
            second={() => {
              if (props.order === 4) {
                props.jump(1);
              } else {
                props.jump(4);
              }
            }}
            third={() => {
              if (props.order === 4) {
                props.jump(1);
              } else {
                props.jump(4);
              }
            }}
          />
          {stepDesc[3] !== undefined && (
            <div className="text-middle"
            dangerouslySetInnerHTML={{ __html: stepDesc[3].description }}
            >
              {/* <Text
                desc={stepDesc[3] !== undefined && stepDesc[3].description}
              /> */}
            </div>
          )}
          <div className="buttons">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor4 }}
              >
                NEXT STEP
              </button>
            </div>
        </div>
        <div className="shapes">
          <Elements  eleclass="elements34"/>
          <div className="cont-step4">
            <div className="shapes-form-container-step4">
              <div className="shapes-form">
                <div className="shape-input mrg">
                  <div className="shape-imgStep4">
                    {cartItems[0] && (
                      <div className="cart-img">{unitImg[0]}</div>
                    )}
                    {cartItems[1] && (
                      <div className="cart-img">{unitImg[1]}</div>
                    )}
                    {cartItems[2] && (
                      <div className="cart-img">{unitImg[2]}</div>
                    )}
                    <img className="polishred" src={polishred} alt="red" />
                  </div>
                  {/* //<div className={cx("mrg-cont", shape.find(obj => obj.id === 1) ? "active" : ""
              )} */}
                  <div className="shape-radio-step4">
                    <div>{listPortion[0]}</div>
                    <div>{listPortion[1]}</div>
                    <div>{listPortion[2]}</div>
                    <div>{listPortion[3]}</div>
                  </div>
                </div>
              </div>
            </div>
            <div className="buttons btn-dwn4">
              <button
                className="btn-prev"
                onClick={props.prev}
                style={{ background: "#ff262d" }}
              >
                BACK STEP
              </button>
              <button
                className="btn-next"
                onClick={handleNext}
                style={{ background: btnColor4 }}
              >
                NEXT STEP
              </button>
            </div>
          </div>
        </div>
       
      </div>
    </>
  );
}

export default Stepfour;
